module.exports = __webpack_public_path__ + "static/img/10.2fda8fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/10.png
// module id = VbHZ
// module chunks = 0